import { api } from "@/services/api";
import {
  ReferAndEarnReferralsProps,
  ReferAndEarnSettingsProps
} from "@/@types/ReferAndEarn";

async function getSettings(currency?: string): Promise<ReferAndEarnSettingsProps> {
  const response = await api.get('/v1/referrals/settings', { params: { currency } });
  return response.data;
}

async function getReferrals(page: number, currency?: string): Promise<ReferAndEarnReferralsProps> {
  const response = await api.get(`/v1/referrals`, { params: { page, currency } });
  return response.data;
}

export const ReferAndEarnService = {
  getSettings,
  getReferrals,
};
